import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  QuestionLabel,
  Container,
  TextError,
} from '../styles';

import {
  MatrixTableContainer,
  TableWrapper,
  TableRow,
  TableCell,
  RadioBox,
} from './styles';

const MatrixQuestionType = (props) => {
  const {
    label,
    questionOptions,
    onChange,
    selectedValue,
    errorField,
    errorText,
    matrixType,
  } = props;
  const [selectedOptions, setSelectedOptions] = useState({});

  const rows = useMemo(() => _.orderBy(
    _.filter(questionOptions, (option) => option.matrixOption === 'row'),
    ['order'],
    ['asc'],
  ), [questionOptions]);

  const columns = useMemo(() => _.orderBy(
    _.filter(questionOptions, (option) => option.matrixOption === 'column'),
    ['order'],
    ['asc'],
  ), [questionOptions]);

  const handleClickCheckbox = (rowId, columnId) => {
    setSelectedOptions((prevSelectedValues) => {
      const updatedSelection = matrixType === 'multiple_select'
        ? {
          ...prevSelectedValues,
          [rowId]: prevSelectedValues[rowId]?.includes(columnId)
            ? prevSelectedValues[rowId].filter((id) => id !== columnId)
            : [...(prevSelectedValues[rowId] || []), columnId],
        }
        : {
          ...prevSelectedValues,
          [rowId]: columnId,
        };

      onChange(updatedSelection);
      return updatedSelection;
    });
  };

  const isFieldError = (rowId) => {
    if (matrixType === 'single_select') {
      return errorField && !selectedValue[rowId];
    }
    /// multiple select
    return errorField && _.isEmpty(selectedValue[rowId]);
  };

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>
      <MatrixTableContainer>
        <TableWrapper>
          <TableRow>
            <TableCell />
            {columns.map((column) => (
              <TableCell title={column.label} key={column.label}>{column.label}</TableCell>
            ))}
          </TableRow>
          {rows.map((row) => (
            <TableRow key={row.id}>
              {
                isFieldError(row.id) ? (
                  <TableCell row={+true} title={row.label} error={+errorField}>{row.label}</TableCell>
                ) : <TableCell row={+true} title={row.label}>{row.label}</TableCell>
              }
              {columns.map((column) => (
                <TableCell key={`${row.id}-${column.id}`}>
                  {
                    matrixType === 'single_select' && (
                      <RadioBox
                        data-matrix-single-checked={selectedValue[row.id] === column.id || selectedOptions[row.id] === column.id}
                        data-matrix-type="single_select"
                        radio
                        className={isFieldError(row.id) ? 'customBackground' : null}
                        onChange={() => handleClickCheckbox(row.id, column.id)}
                        checked={selectedValue[row.id] === column.id || selectedOptions[row.id] === column.id}
                      />
                    )
                  }
                  {
                    matrixType === 'multiple_select' && (
                      <RadioBox
                        data-matrix-multiple-checked={selectedOptions[row.id]?.includes(column.id)}
                        data-matrix-type="multiple_select"
                        checkbox
                        className={isFieldError(row.id) ? 'customBackground' : null}
                        onChange={() => handleClickCheckbox(row.id, column.id)}
                        checked={selectedOptions[row.id]?.includes(column.id)}
                      />
                    )
                  }
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableWrapper>
      </MatrixTableContainer>
      {
        errorField && (
          <TextError>
            {errorText}
          </TextError>
        )
      }
    </Container>
  );
};

MatrixQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    order: PropTypes.number,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string.isRequired,
  errorField: PropTypes.bool,
  errorText: PropTypes.string,
  matrixType: PropTypes.string.isRequired,
};

MatrixQuestionType.defaultProps = {
  errorField: false,
  errorText: 'Please select an option for each row',
};

export default MatrixQuestionType;
